<template>
  <div>
    <PageFirstHeader></PageFirstHeader>
    <PageHeader @updateProductType="updateProductTypeChange" @selectArea="selectArea" @serfunch="serfunch"
      @Ranking="Ranking" @allHeader="allHeader" @delKeyWord="delKeyWord" ref="headerRef">
    </PageHeader>
    <router-view :updateProductType="updateProductType" ref="myviewRef" @delHeader="delHeader" @delHeas="delHeas"
      @clearFun="clearFun"></router-view>
    <PageFooter></PageFooter>
  </div>
</template>

<script>
import PageFirstHeader from "@/components/PageFirstHeader.vue";
import PageHeader from '@/components/PageHeader.vue'
import PageFooter from '@/components/PageFooter.vue'
export default {
  name: "Layout",
  components: {
    PageFirstHeader,
    PageHeader,
    PageFooter
  },
  data() {
    return {
      // state
      updateProductType: "",
      timer: null
    };
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    selectArea(obj) {//新增地址筛选
      // this.$nextTick(() => {
      // DOM更新后执行的代码
      this.$refs.myviewRef.Filtercities({
        name: obj.name,
        code: obj.code
      });
      // });
    },

    allHeader(type) {
      this.$refs.myviewRef.isNes = true
      this.$nextTick(() => {
        // console.log(`key:${type.key},name:${type.name}  22`);

        this.timer = setInterval(() => {
          try {
            this.$refs.myviewRef.allHeader({
              categoryId: type.key,
              names: type.name
            })
            clearInterval(this.timer)
          } catch (error) {
          }

        }, 100);

        setTimeout(() => {
          clearInterval(this.timer)
        }, 3000);
      })

    },
    updateProductTypeChange(e) {
      this.updateProductType = String(e);
    },
    // method
    serfunch(obj) {
      this.$nextTick(() => {
        // DOM更新后执行的代码
        this.$refs.myviewRef.myviewFun({
          name: obj.keywords
        });
      });

    },
    Ranking(obj) { //分类筛选  商家排行
      this.$refs.myviewRef.searchRanking(obj.mainBusiness);
    },
    delKeyWord() {
      this.$refs.myviewRef.delKeyWord()
    },

    clearFun() {
      this.$refs.headerRef.headerRefFun()
    },
    delHeader() {
      this.$refs.headerRef.delHeader()
    },
    delHeas(type) {
      this.$refs.headerRef.delHeas(type)

    },
  },

};
</script>

<style lang="scss" scoped>
/* scoped css */
</style>
